import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { timeout } from 'rxjs';
import { environment } from '../environments/environment';
import { Environment, environments } from './configuration-view';
import { SourceAuthService } from './source-auth.service';

export interface ConfigurationWaterfall {
  type: string;
  key: string;
  organizationName: string;
  swaggerName: string;
  isTemplate: boolean | null;
  stableApplicationData: string | null;
  stableApiCoreData: string | null;
  alfaApplicationData: string | null;
  alfaApiCoreData: string | null;
  betaApplicationData: string | null;
  betaApiCoreData: string | null;
  prodApplicationData: string | null;
  prodApiCoreData: string | null;
  stableUpdatedBy: string | null;
  stableUpdatedAt: string | null;
  alfaUpdatedBy: string | null;
  alfaUpdatedAt: string | null;
  betaUpdatedBy: string | null;
  betaUpdatedAt: string | null;
  prodUpdatedBy: string | null;
  prodUpdatedAt: string | null;
}

export interface ConfigurationChangeHistory {
  id: string;
  source: string;
  remoteId: string;
  createdAt: string;
  changedBy: string | null;
  previousApplicationData: string | null;
  applicationData: string | null;
  previousApiCoreData: string | null;
  apiCoreData: string | null;
}

@Injectable({ providedIn: 'root' })
export class ConfigurationWaterfallService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(SourceAuthService);

  getAll() {
    return this.http.get<ConfigurationWaterfall[]>(`${environment.apiUrl}/api/configuration-comparator`).pipe(timeout(30_000));
  }

  refresh() {
    return this.http.post<ConfigurationWaterfall[]>(`${environment.apiUrl}/api/configuration-comparator/refresh`, {}, {
      headers: this.auth.tokenHeaders(environments.map(env => env.id)),
    }).pipe(timeout(120_000));
  }

  update(row: ConfigurationWaterfall, source: Environment, data: string) {
    return this.http.put<ConfigurationWaterfall>(`${environment.apiUrl}/api/configuration-comparator/${source}`, {
      type: row.type,
      key: row.key,
      organizationName: row.organizationName,
      swaggerName: row.swaggerName,
      isTemplate: row.isTemplate,
      data,
    }, {
      headers: this.auth.tokenHeaders([source]),
    }).pipe(timeout(60_000));
  }

  history(row: ConfigurationWaterfall, source: Environment) {
    let params = new HttpParams()
      .set('type', row.type)
      .set('key', row.key)
      .set('organizationName', row.organizationName)
      .set('swaggerName', row.swaggerName);
    if (row.isTemplate !== null) params = params.set('isTemplate', String(row.isTemplate));
    return this.http.get<ConfigurationChangeHistory[]>(`${environment.apiUrl}/api/configuration-comparator/${source}/history`, {
      params,
      headers: this.auth.tokenHeaders([source]),
    }).pipe(timeout(30_000));
  }
}
